import { isPermalinkPath } from '@/features/seo-listing/consts';

/**
 * Catalog breadcrumb / header «Фанфики» while query filters are active must hard
 * navigate like SEO permalinks. Soft reset alone can leave filters/H1 stale
 * (listing-restore capture + pushState races) while the address bar already
 * shows /fanfics.
 */
export const shouldHardResetCatalogNavigation = ({
  destinationPath,
  basePath,
  browserPathname,
  browserSearch,
  selectedFandomsCount,
  selectedCharactersCount,
  selectedTagsCount,
  selectedPairingCharactersCount,
  isNextPathPermalink,
}: {
  destinationPath: string;
  basePath: string;
  browserPathname: string;
  browserSearch: string;
  selectedFandomsCount: number;
  selectedCharactersCount: number;
  selectedTagsCount: number;
  selectedPairingCharactersCount: number;
  isNextPathPermalink: boolean;
}): boolean => {
  const normalizedDestination = destinationPath.split('?')[0] ?? destinationPath;
  if (normalizedDestination !== basePath) {
    return true;
  }

  if (isNextPathPermalink || isPermalinkPath(browserPathname)) {
    return true;
  }

  const hasQueryListingFilters = /(?:^|[?&])(?:fandoms|characters|tags|pairingCharacters)=/.test(
    browserSearch,
  );
  const hasClientListingFilters =
    selectedFandomsCount > 0 ||
    selectedCharactersCount > 0 ||
    selectedTagsCount > 0 ||
    selectedPairingCharactersCount > 0;

  return hasQueryListingFilters || hasClientListingFilters;
};
